export default __webpack_public_path__ + "static/media/8.fbee22f9.jpg";